module.exports = {
	/*
	original svg
	<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><path d="M8 24l2.83 2.83L22 15.66V40h4V15.66l11.17 11.17L40 24 24 8 8 24z"/></svg>
	@ material-design-icons/navigation/svg/production/ic_arrow_upward_48px.svg
	*/
	d: 'M8 24l2.83 2.83L22 15.66V40h4V15.66l11.17 11.17L40 24 24 8 8 24z',
	width: 48,
	height: 48,
	
};